import { SEND_EVENT_TO_CLEVERTAP } from '../utils/constant';

export const sendEventToClevertap = (payload) => ({
  type: SEND_EVENT_TO_CLEVERTAP,
  payload,
  
  
});
